import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { catalogueDetailsCurrentPeriod, catalogueDetailsEndDate } from "../@signals"


export const catalogueDetailsEvolutionDateRange = [
    {
        label: "Yesterday",
        value: () => { return [getPreviousDate({ days: 1 }, catalogueDetailsEndDate.value), getPreviousDate({ days: 1 }, catalogueDetailsEndDate.value)] },
        placement: "left",
        onFocus: () => catalogueDetailsCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: "Last 7 Days",
        value: () => { return [getPreviousDate({ days: 6 }, catalogueDetailsEndDate.value), stringToDate(catalogueDetailsEndDate.value)] },
        placement: "left",
        onFocus: () => catalogueDetailsCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: "Last 30 Days",
        value: () => { return [getPreviousDate({ days: 29 }, catalogueDetailsEndDate.value), stringToDate(catalogueDetailsEndDate.value)] },
        placement: "left",
        onFocus: () => catalogueDetailsCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: "Last Month",
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(catalogueDetailsEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(catalogueDetailsEndDate.value).setDate(1)))
            ]
        },
        placement: "left",
        onFocus: () => evolutionOffersCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]